exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-error {\n    color: indianred;\n    height: 20px;\n    margin-bottom: 15px;\n    margin-left: 1px;\n    margin-right: 1px;\n    padding-top: 9px;\n    font: bold 12px/1 arial, sans-serif\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main